export default __webpack_public_path__ + "static/media/blog-hillside-retaining-002.894c1753.jpg";